module.exports = __webpack_public_path__ + "static/media/front.ff9d8377.jpg";